<template>
    <el-button icon="Delete" text :type="row.algoId ? 'primary' : 'info'" @click="cancelOrder()" :loading="loading" />
</template>

<script setup>
import { toRaw, ref } from "vue"
import { ElMessage } from 'element-plus'
import { useSystemStore } from '@/stores/system'
import { useLogStore } from '@/stores/log'

const props = defineProps({
    row: Object
})
const systemStore = useSystemStore()
const logStore = useLogStore()
const loading = ref(false)

const cancelOrder = async () => {
    if (!props.row.algoId) return
    try {
        loading.value = true
        await systemStore.privateClient.cancelAlgos(props.row.algoId, props.row.instId)
        ElMessage.success('已撤销')
        loading.value = false
    } catch (error) {
        ElMessage.error('撤销失败: ' + error.message)
        loading.value = false
        logStore.addLog({
            title: '撤销订单失败',
            level: 'error',
            message: error
        })
    }
}

</script>